// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".skill-tag{margin-right:.25rem;margin-top:.25rem;padding:2px 10px;border-radius:10px}.weaknesses{color:#991b1b;background-color:#fee2e2}.strengths{color:#065f46;background-color:#d1fae5}.blindspots{color:#5b21b6;background-color:#ede9fe}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
